import { render, staticRenderFns } from "./BreaksManagementWidget.vue?vue&type=template&id=3924c200&"
import script from "./BreaksManagementWidget.vue?vue&type=script&lang=js&"
export * from "./BreaksManagementWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports